import  { useState , useEffect} from 'react'
import { useIndexedDB } from 'react-indexed-db'
import imageCompression from 'browser-image-compression'
import maskGroup from '../../Assets/Bisoft_UI/AppMode/maskGroup@1.png'
import Slider from './Slider.js'
import styles from './Appmode.module.css'
import renderImage from '../../source/importImg'

const Action = (props) => {
    const { update, deleteRecord } = useIndexedDB('ProgramData')
    let enable = JSON.parse(sessionStorage.getItem('enable'))
    const connectedDevice = sessionStorage.getItem('connectedDevice') || 'Ace'
    let allDetails = {}
    const uploadId = `upload-image-${props.value}`

 
    useEffect(() => {
        try {
            const stored =
                JSON.parse(sessionStorage.getItem('allDetails')) || {}
            if (stored[props.value]) {
                Object.assign(props.object, stored[props.value])
            }
        } catch (e) {
            console.warn(
                'Action: failed to sync props.object from sessionStorage',
                e
            )
        }
    }, [props.value, props.object])

    const [image, setImage] = useState(() => {
        if (
            sessionStorage.getItem('allDetails') !== null &&
            `${props.value}` in
                JSON.parse(sessionStorage.getItem('allDetails')) &&
            JSON.parse(sessionStorage.getItem('allDetails'))[`${props.value}`]
                .image !== null
        ) {
            return JSON.parse(sessionStorage.getItem('allDetails'))[
                `${props.value}`
            ].image
        } else {
            return 'Upload Image'
        }
    })

    useEffect(() => {
        const all = JSON.parse(sessionStorage.getItem('allDetails')) || {}

        if (all[props.value]?.image) {
            setImage(all[props.value].image)
        } else {
            setImage('Upload Image')
        }
    }, [props.value])

    const [input, setInput] = useState(() => {
        if (
            sessionStorage.getItem('allDetails') !== null &&
            `${props.value}` in
                JSON.parse(sessionStorage.getItem('allDetails')) &&
            JSON.parse(sessionStorage.getItem('allDetails'))[`${props.value}`]
                .displayText !== null
        ) {
            return JSON.parse(sessionStorage.getItem('allDetails'))[
                `${props.value}`
            ].displayText
        } else {
            return null
        }
    })

    const [select, setSelect] = useState(() => {
        if (
            sessionStorage.getItem('allDetails') !== null &&
            `${props.value}` in
                JSON.parse(sessionStorage.getItem('allDetails')) &&
            JSON.parse(sessionStorage.getItem('allDetails'))[`${props.value}`]
                .selectedSize !== null
        ) {
            return JSON.parse(sessionStorage.getItem('allDetails'))[
                `${props.value}`
            ].selectedSize
        } else {
            return 'Select Size'
        }
    })

    const [sliderOption, setSliderOption] = useState(() => {
        if (
            sessionStorage.getItem('allDetails') !== null &&
            `${props.value}` in
                JSON.parse(sessionStorage.getItem('allDetails')) &&
            JSON.parse(sessionStorage.getItem('allDetails'))[`${props.value}`]
                .sliderOption !== null
        ) {
            return JSON.parse(sessionStorage.getItem('allDetails'))[
                `${props.value}`
            ].sliderOption
        } else {
            return 'Select an Option'
        }
    })

    const [slider, setSlider] = useState(() => {
        if (
            sessionStorage.getItem('allDetails') !== null &&
            `${props.value}` in
                JSON.parse(sessionStorage.getItem('allDetails')) &&
            JSON.parse(sessionStorage.getItem('allDetails'))[`${props.value}`]
                .sliderValue !== null
        ) {
            return JSON.parse(sessionStorage.getItem('allDetails'))[
                `${props.value}`
            ].sliderValue
        } else {
            return 0
        }
    })

    const save = (object) => {
        allDetails = JSON.parse(sessionStorage.getItem('allDetails')) || {}
        if (object.id in allDetails) {
            if (
                object.displayText !== null &&
                allDetails[object.id]['displayText'] !== object.displayText
            ) {
                allDetails[object.id]['displayText'] = object.displayText
            }
            if (
                object.image !== null &&
                allDetails[object.id]['image'] !== object.image
            ) {
                allDetails[object.id]['image'] = object.image
            }
            if (
                object.imageURL !== null &&
                allDetails[object.id]['imageURL'] !== object.imageURL
            ) {
                allDetails[object.id]['imageURL'] = object.imageURL
            }
            if (
                object.selectedSize !== null &&
                allDetails[object.id]['selectedSize'] !== object.selectedSize
            ) {
                allDetails[object.id]['selectedSize'] = object.selectedSize
            }
            if (
                object.sliderOption !== null &&
                allDetails[object.id]['sliderOption'] !== object.sliderOption
            ) {
                allDetails[object.id]['sliderOption'] = object.sliderOption
            }
            if (
                object.sliderValue !== null &&
                allDetails[object.id]['sliderValue'] !== object.sliderValue
            ) {
                allDetails[object.id]['sliderValue'] = object.sliderValue
            }
        } else {
            allDetails[`${object.id}`] = object
        }
        sessionStorage.setItem('allDetails', JSON.stringify(allDetails))
        
    }

    const data = (event) => {
        const compressImage = async (image) => {
            const imageFile = image
            const options = {
                maxSizeMB: 1,
                maxWidthOrHeight: 1920,
                useWebWorker: true,
            }
            try {
                const compressedFile = await imageCompression(
                    imageFile,
                    options
                )
                var reader = new FileReader()
                reader.onloadend = function () {
                    update({ id: props.value, imageURL: `${reader.result}` })
                }
                reader.readAsDataURL(compressedFile)
            } catch (error) {
                console.log(error)
            }
        }
        if (event.target.type === 'file') {
            props.object['image'] = event.target.files[0]['name']
            compressImage(event.target.files[0])
            setImage(event.target.files[0]['name'])
        } else if (event.target.type === 'select-one') {
            if (event.target.value.length === 1) {
                props.object['selectedSize'] = event.target.value
                setSelect(event.target.value)
            } else {
                props.object['sliderOption'] = event.target.value
                setSliderOption(event.target.value)
            }
        } else if (
            event.target.type === 'range' ||
            event.target.type === 'number'
        ) {
            if (event.target.value > 255) {
                props.object['sliderValue'] = Number(255)
            } else {
                props.object['sliderValue'] = event.target.value
            }
        } else {
            props.object['displayText'] = event.target.value
            setInput(event.target.value)
        }
        save(props.object)
    }

    //get device name that show in ui
    const getDeviceName = () => {
        switch (connectedDevice) {
            case 'Ace':
                return 'PC'
            case 'Humanoid':
                return 'Zing'
            case 'Hexapod':
                return 'Crawl-e'
            case 'Klaw':
                return 'Klaw-b'
            case 'Roboki':
                return 'Roboki'
            case 'Autoki':
                return 'Autoki'
            case 'Klaw':
                return 'Klaw-b'
            default:
                return connectedDevice
        }
    }

    const handelDeleteImgInput = () => {
        deleteRecord(props.value)
            .then(() => {
                // console.log(
                //     `Record with id ${props.value} deleted successfully`
                // )
                setImage('Upload Image')
                allDetails =
                    JSON.parse(sessionStorage.getItem('allDetails')) || {}
                if (allDetails[props.value]) {
                    allDetails[props.value].image = null
                }

                sessionStorage.setItem('allDetails', JSON.stringify(allDetails))
            })
            .catch((err) => {
                console.error('Error deleting record:', err)
            })
    }

    return (
        <div style={{ margin: '0px' }}>
            <div>
                <img
                    src={maskGroup}
                    draggable="false"
                    alt="maskGroup"
                    style={{
                        margin: 0,
                        position: 'absolute',
                        top: '37.6vh',
                        left: '48vw',
                        width: '80vw',
                        height: '10vh',
                        //-ms-transform: "translate(-50%, -50%)",
                        transform: 'translate(-50%, -50%)',
                    }}
                />
                {/* Element to Move Dynamically */}
                <span
                    className={styles.labelTag}
                    style={{
                        position: 'absolute',
                        top: '37.6vh',
                        left: '12vw',
                        transform: 'translateY(-50%)',
                    }}
                >
                    ACTION
                </span>
                <span
                    className={styles.labelTag}
                    style={{
                        position: 'absolute',
                        top: '37.6vh',
                        left: '22vw',
                        transform: 'translateY(-50%)',
                        color: '#888',
                    }}
                >
                    Display Image
                </span>
                <div
                    style={{
                        position: 'absolute',
                        top: '37.6vh',
                        left: '38vw',
                        transform: 'translateY(calc(-50% - 6px))',
                        height: '5.5vh',
                        width: '20vw',
                        padding: '0 10px',
                        backgroundColor: 'white',
                        border: '1.5px solid #d1d1d1',
                        borderRadius: '12px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                        fontFamily: 'Halcyon Regular',
                        fontSize: '14px',
                        transition: 'all 0.3s ease',
                    }}
                >
                    <input
                        type="file"
                        id={uploadId}
                        hidden
                        accept="image/png, image/jpeg"
                        onChange={data}
                    />
                    <label
                        style={{
                            marginBottom: '0',
                            cursor: 'pointer',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}
                        htmlFor={uploadId}
                    >
                        {image}
                    </label>
                </div>
                <div
                    style={{
                        position: 'absolute',
                        top: '37.6vh',
                        left: '68vw',
                        transform: 'translateY(-50%)',
                        cursor: 'pointer',
                    }}
                >
                    <img
                        onClick={handelDeleteImgInput}
                        style={{ width: '35px' }}
                        src={renderImage('deleteBtn')}
                        alt="Delete"
                    />
                </div>
            </div>
            <div>
                <img
                    src={maskGroup}
                    alt="maskGroup"
                    draggable="false"
                    style={{
                        margin: 0,
                        position: 'absolute',
                        top: '45.6vh',
                        left: '48vw',
                        width: '80vw',
                        height: '10vh',
                        transform: 'translate(-50%, -50%)',
                    }}
                />
                <span
                    className={styles.labelTag}
                    style={{
                        position: 'absolute',
                        top: '45.6vh',
                        left: '12vw',
                        transform: 'translateY(-50%)',
                    }}
                >
                    ACTION
                </span>
                <span
                    className={styles.labelTag}
                    style={{
                        position: 'absolute',
                        top: '45.6vh',
                        left: '22vw',
                        transform: 'translateY(-50%)',
                        color: '#888',
                    }}
                >
                    Display Text
                </span>
                <input
                    style={{
                        margin: 0,
                        position: 'absolute',
                        top: '45.6vh',
                        left: '38vw',
                        width: '20vw',
                        textAlign: 'center',
                        transform: 'translateY(calc(-50% - 6px))',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}
                    key={props.id}
                    id={props.value}
                    className={styles.inputWrapper}
                    type="text"
                    maxLength={16}
                    placeholder="Enter Text"
                    onChange={data}
                    value={input || ''}
                />
                <span
                    className={styles.labelTag}
                    style={{
                        position: 'absolute',
                        top: '45.6vh',
                        left: '62vw',
                        transform: 'translateY(-50%)',
                        color: '#888',
                    }}
                >
                    Select Size
                </span>
                <div
                    style={{
                        position: 'absolute',
                        top: '45.6vh',
                        left: '70vw',
                        transform: 'translateY(calc(-50% - 6px))',
                    }}
                >
                    <select
                        className={styles.selectBox}
                        style={{
                            width: '9vw',
                            textAlign: 'center',
                        }}
                        id={props.value}
                        value={select}
                        onChange={data}
                    >
                        <option value="0">Select Size</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                    </select>
                </div>
            </div>
            {/* MaskGroup3 */}
            {enable.s1.pc === true ? (
    <div>
        <img
            src={maskGroup}
            alt="maskGroup"
            draggable="false"
            style={{
                margin: 0,
                position: 'absolute',
                top: '53.6vh',
                left: '48vw',
                width: '80vw',
                height: '10vh',
                transform: 'translate(-50%, -50%)',
            }}
        />

        <span
            className={styles.labelTag}
            style={{
                position: 'absolute',
                top: '53.6vh',
                left: '12vw',
                transform: 'translateY(-50%)',
            }}
        >
            ACTION
        </span>

        <div
            style={{
                position: 'absolute',
                top: '53.6vh',
                left: '38vw',
                transform: 'translateY(calc(-50% - 6px))',
            }}
        >
            <select
                className={styles.selectBox}
                style={{
                    width: '20vw',
                    textAlign: 'center',
                }}
                id={props.value}
                value={sliderOption}
                onChange={data}
            >
                <option value="none">Select an Option</option>
                <option value="TX1">
                    {`Send to ${getDeviceName()} (USB RX)`}
                </option>
            </select>
        </div>

        {sliderOption === 'TX1' && (
            <Slider
                save={data}
                setslider={setSlider}
                slider={slider}
                value={props.value}
                top="50vh"
                right="23vw"
                usbRx={true}
            />
        )}
    </div>
) : null}
        </div>
    )
}
export default Action
